import { ethers as r } from "ethers";
import { DOBStakingPoolContractAbi as n } from "@deorderbook/contracts/abi";
import { DOBStakingPoolAddress as e } from "@deorderbook/contracts";
import { signer as i, provider as c } from "./provider.mjs";
const a = () => new r.Contract(
  e,
  n
), g = (t = !1) => {
  const o = a();
  return t ? o.connect(i) : o.connect(c);
};
export {
  a as initDOBStakingPoolContract,
  g as useDOBStakingPoolContract
};
//# sourceMappingURL=dobStakingPoolContract.mjs.map
